import store from '@/ambiente/store'
import Biblioteca from '@/components/Repositorio/Biblioteca'

export default {
  carregouSessao() {
    if (!store.state.usuario_logado) {
      return false;
    }
    else if (!store.state.usuario_logado.funcionario_id) {
      return false;
    }
    else if (!store.state.usuario_logado.funcionario_id > 0) {
      return false;
    }
    
    return true;
  },

  async eUsuarioGerente() {
    if (!this.carregouSessao()) {
      return false;
    }

    return (
      store.state.parametros_gerais.usuario_santri_id ==  
      store.state.usuario_logado.funcionario_id
    );
  },

  async buscarStatusSessao(api) {
    let parametros = {
      operacao: 'buscarStatusSessao'
    };

    let retorno = {};

    await api.santriGET('/rest/sessao?', parametros, 0, false)
    .then(resposta => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, resposta.data);
    })
    .catch(erro => {
      retorno = Biblioteca.retornoRequisicao('S', erro, undefined);
    })

    return retorno;
  },

  buscarAutorizacaoTela(api, parametros) {
    parametros.operacao = 'buscarAutorizacaoTela';

    return new Promise((sucesso, fracasso) => {
      api.santriGET('/rest/sessao', parametros, 0, true)
      .then(response => {
        sucesso(Biblioteca.retornoRequisicao('N', undefined, response.data));
      })
      .catch(erro => {
        fracasso(Biblioteca.retornoRequisicao('S', erro, undefined));
      })
    })
  },

  async verificarRestricaoLogin(mensagem){
    if (!mensagem){
      return;
    }

    if (mensagem.indexOf("Atenção restrição de login ativa") > -1){
      await this.setExigirCertificacaoUsuario('S');
    }
  },

  async setExigirCertificacaoUsuario(exigir_certificacao_login){
    let dados_sessao_usuario = await JSON.parse(localStorage.getItem('dados_sessao_usuario'));
    dados_sessao_usuario.exigir_certificacao_login = exigir_certificacao_login;
    
    await localStorage.setItem('dados_sessao_usuario', JSON.stringify(dados_sessao_usuario));
  },

  async setDadosSessaoUsuario(exigir_certificacao_login, tipo_autenticacao, usuario_id){
    let dados_sessao_usuario = {
      usuario_id: usuario_id,
      tipo_autenticacao: tipo_autenticacao,
      exigir_certificacao_login: exigir_certificacao_login
    };

    await localStorage.setItem('dados_sessao_usuario', JSON.stringify(dados_sessao_usuario));
  },

  async getDadosSessaoUsuario(){
    return await JSON.parse(localStorage.getItem('dados_sessao_usuario'));
  },

  async autorizado(chave){
    let buscou_dados_sessao = await this.carregouSessao();

    if (!buscou_dados_sessao){
      await buscarDadosCarregarSessao(this.axios);         
    }

    if (store.state.usuario_logado.gerente == 'S'){
      return true;
    }

    if (!store.state.autorizacoes){
      return false;
    }

    let autorizacoes = await JSON.parse(JSON.stringify(store.state.autorizacoes));

    let retorno = false;
    for (let i = 0; i < autorizacoes.length; i++) {
      if (autorizacoes[i] == chave){
        retorno = true;
        break;
      }
    }

    return retorno;
  },

  async buscarDadosCarregarSessao(api) {
    let parametros = {
      operacao: 'buscarDadosCarregarSessao'
    }

    await api.santriGET('/rest/sessao', parametros, 0, false)
    .then(async resposta => {
      let retorno = JSON.parse(JSON.stringify(resposta.data))

      if (retorno.parametros_gerais){
        await store.commit(
          'SET_PARAMETROS_GERAIS',
          JSON.parse(JSON.stringify(retorno.parametros_gerais))
        );
      }

      if (retorno.parametros_empresa) {
        await store.commit(
          'SET_PARAMETROS_EMPRESA',
          JSON.parse(JSON.stringify(retorno.parametros_empresa))
        );
      }

      if (retorno.usuario_logado){
        await store.commit(
          'SET_USUARIO_LOGADO',
          JSON.parse(JSON.stringify(retorno.usuario_logado))
        );
      }

      if (retorno.autorizacoes){
        await store.commit(
          'SET_AUTORIZACOES',
          JSON.parse(JSON.stringify(retorno.autorizacoes))
        );
      }

      // Buscar foto somente se for usuário ADM
      if 
        (
          (retorno.usuario_logado) && 
          (retorno.usuario_logado.tipo_autenticacao == 'UAD')
        ) 
      {
        let foto_local_str = localStorage.getItem('sessao_foto_usuario');
        let foto_local = undefined;
        if (foto_local_str) {
          foto_local = JSON.parse(foto_local_str);

          if (foto_local.funcionario_id != retorno.usuario_logado.funcionario_id) {
            foto_local = undefined;
          }

          if (
            (foto_local) && 
            (Biblioteca.diferencaHoras(foto_local.data_hora_consulta, new Date()) > 24)
          ) {
            foto_local = undefined;
          }
        }

        if (!foto_local) {
          let retorno_foto = await this.buscarFotoFuncionarioSessao(api);
          if (retorno_foto.houve_erro != 'N') {
            throw new Error(retorno_foto.mensagem);
          }

          foto_local = JSON.parse(JSON.stringify(retorno_foto.dados));
        }

        if (foto_local) {
          await store.commit(
            'SET_FOTO_USUARIO_LOGADO',
            foto_local
          );

          localStorage.setItem('sessao_foto_usuario', JSON.stringify(foto_local));
        }
      }

      if (retorno.empresa_logada) {
        await store.commit(
          'SET_EMPRESA_LOGADA',
          JSON.parse(JSON.stringify(retorno.empresa_logada))
        );
      }

      if (retorno.empresas) {
        await store.commit(
          'SET_EMPRESAS_AUTORIZADAS',
          JSON.parse(JSON.stringify(retorno.empresas))
        );
      }

      if (retorno.parametros_adm_servicos) {
        await store.commit(
          'SET_PARAMETROS_ADM_SERVICOS',
          JSON.parse(JSON.stringify(retorno.parametros_adm_servicos))
        );
      }
    })
    .catch(erro => {
      store.commit('LIMPAR_SESSAO', undefined);
      console.log('erro na sessão', JSON.stringify(erro))
    });
  },
  
  async trocarEmpresa(api, parametros) {
    parametros.operacao = 'trocarEmpresa';

    let retorno = {};

    await api.santriPOST('/rest/sessao', parametros, 0, false)
      .then(resposta => {
        retorno = Biblioteca.retornoRequisicao('N', undefined, resposta.data);
      })
      .catch(erro => {
        retorno = Biblioteca.retornoRequisicao('S', erro, undefined);
      });

    return retorno;
  },

  async criarSessao(api, parametros) {
    parametros.operacao = 'criarSessao';

    let retorno = {};

    await api.santriPOST('/rest/sessao', parametros, 0, false)
      .then(resposta => {
        retorno = Biblioteca.retornoRequisicao('N', undefined, resposta.data);
      })
      .catch(erro => {
        retorno = Biblioteca.retornoRequisicao('S', erro, undefined);
      });

    return retorno;
  },
  
  async criarSessaoTerceiro(api, parametros) {
    parametros.operacao = 'criarSessaoTerceiro';

    let retorno = {};

    await api.santriPOST('/rest/sessao', parametros, 0, false)
      .then(resposta => {
        retorno = Biblioteca.retornoRequisicao('N', undefined, resposta.data);
      })
      .catch(erro => {
        retorno = Biblioteca.retornoRequisicao('S', erro, undefined);
      });

    return retorno;
  },

  async buscarDadosSessaoTerceiros(api) {
    let parametros = {
      operacao: 'buscarDadosSessaoTerceiro'
    }
    let retorno = {};

    await api.santriGET('/rest/sessao', parametros, 0, false)
      .then(resposta => {
        retorno = Biblioteca.retornoRequisicao('N', undefined, resposta.data);
      })
      .catch(erro => {
        retorno = Biblioteca.retornoRequisicao('S', erro, undefined);
      });

    return retorno;
  },

  async buscarAutorizacoesDashboard(api) {
    let parametros = {
      operacao: 'buscarAutorizacoesDashboard'
    }

    let retorno = {};

    await api.santriGET('/rest/sessao', parametros, 0, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async autorizar(api, parametros) {
    parametros.operacao = 'autorizar';

    let retorno = {};

    await api.santriPOST('/rest/sessao', parametros, 0, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarDadosIniciaisTelaConfirmacaoSaidaProdutos(api) {
    let parametros = {
      operacao: 'buscarDadosIniciaisTelaConfirmacaoSaidaProdutos'
    }

    let retorno = {};

    await api.santriGET('/rest/sessao', parametros, 0, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarDadosIniciaisTelaClientesSimplificados(api) {
    let parametros = {
      operacao: 'buscarDadosIniciaisTelaClientesSimplificados'
    }

    let retorno = {};

    await api.santriGET('/rest/sessao', parametros, 0, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarFotoFuncionarioSessao(api) {
    let parametros = {
      operacao: 'buscarFotoFuncionarioSessao'
    }

    let retorno = {};

    await api.santriGET('/rest/sessao', parametros, 0, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarRelacaoAcessosADMWeb(api, parametros) {
    parametros.operacao = 'buscarRelacaoAcessosADMWeb';

    let retorno = {};

    await api.santriPOST('/rest/sessao', parametros, 0, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }, 

  async buscarAutenticacoesRequisicoes(api, parametros) {
    parametros.operacao = 'buscarAutenticacoesRequisicoes';

    let retorno = {};

    await api.santriPOST('/rest/sessao', parametros, 0, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RSessao.js